/**
 * @ngdoc directive
 * @name shopslideshow
 *
 * @description
 * Products slideshow
 */
module.directive('shopslideshow', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '=',
            reference: '@?'
        },
        controller: ['$scope', 'cart', '$window', 'lodash', function ($scope, $cart, $window, lodash) {
            var referenceCSS = $scope.reference || '.aqua-shop--categories';

            $scope.productsPerLine = 1;
            $scope.defaultProductsPerLine = 4;

            /*
               Slider management
            */
            $scope.position = 0;
            $scope.sliderWidth = 0;
            $scope.slideWidth = 0;

            $scope.getSlideWidth = function () {
                if ($scope.slideWidth !== 0) {
                    return $scope.slideWidth;
                }
                console.log('getSlideWidth');
                var boundings = document.querySelector('.aqua-shop--product').getBoundingClientRect();
                var width = Math.round(boundings.width);
                console.log('found slide width of', width, 'px');
                $scope.slideWidth = width;
                return width;
            };
            $scope.getSliderWidth = function() {
                if ($scope.sliderWidth !== 0) {
                    return $scope.sliderWidth;
                }
                console.log('getSliderWidth');
                var boundings = document.querySelector(referenceCSS).getBoundingClientRect();
                var width = Math.round(boundings.width);
                console.log('found slider width of', width, 'px');
                $scope.sliderWidth = width;
                return width;
            };
            var getSlidesCount = function(nbProducts) {
                var width = $scope.getSlideWidth();
                $scope.productsPerLine = width === $scope.sliderWidth ? 1 : $scope.defaultProductsPerLine;
                console.log('productsPerLine is ', $scope.productsPerLine);
                return Math.ceil(nbProducts / $scope.productsPerLine);
            };
            $scope.getSlidesRange = function(nbProducts) {
                return new Array(getSlidesCount(nbProducts))
            };

            var clearSliderWidth = function() {
                console.log('clearSliderWidth');
                // reset values
                $scope.position = 0;
                $scope.sliderWidth = 0;
                $scope.slideWidth = 0;
                // force layout (products per slide may differ)
                $scope.$digest();
            };

            $scope.changeSlide = function (index) {
                $scope.position = index;
            };

            $scope.nextSlide = function() {
                if ($scope.position < (getSlidesCount($scope.content.length) - 1)) {
                    $scope.position++;
                }
            };
            $scope.prevSlide = function() {
                if ($scope.position > 0) {
                    $scope.position--;
                }
            };

            // check if product is in stock (with stock already in cart)
            $scope.inStock = function (product) {
                var myProduct = lodash.find($cart.products, {id: product.sfid});
                return product.stock - (myProduct ? myProduct.field_quantity : 0) > 0;

            };

            // add product to cart
            $scope.addToCart = function (product) {
                if (!product.pending) {
                    product.pending = true;
                    $cart.addProduct(product).then(function () {
                        product.pending = false;
                        // TODO : add error handler
                    });
                }
            };

            // reestimate slider with when window is resized
            $window.onresize = lodash.throttle(clearSliderWidth, 1000);
        }],
        templateUrl: 'src/components/shopslideshow/shopslideshow.html'
    }
});
